(() => {
  const details = document.querySelector('.localization-selector');
  if (!details) return;
  const storageKey = 'talliv-localization-choice';
  let userInteracted = false;
  details.addEventListener('pointerdown', () => { userInteracted = true; });
  details.addEventListener('keydown', () => { userInteracted = true; });
  details.addEventListener('submit', () => {
    try { localStorage.setItem(storageKey, String(Date.now())); } catch (_) {}
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !details.open) return;
    const currencies = details.querySelector('.localization-currencies');
    const target = currencies.open ? currencies : details;
    target.open = false;
    target.querySelector('summary').focus();
  });
  document.addEventListener('click', event => {
    if (!details.contains(event.target)) details.open = false;
  });
  if (window.Shopify?.designMode || new URLSearchParams(location.search).has('preview_theme_id') || (window.Shopify?.routes?.root || '/') !== '/') return;
  try {
    const saved = Number(localStorage.getItem(storageKey));
    if (saved && Date.now() - saved < 30 * 86400000) return;
    if (sessionStorage.getItem('talliv-localization-checked')) return;
    sessionStorage.setItem('talliv-localization-checked', '1');
  } catch (_) { return; }
  const root = window.Shopify?.routes?.root || '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true')
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      const code = data?.detected_values?.country?.handle;
      if (!code || code === details.dataset.currentCountry || details.open || userInteracted) return;
      const button = Array.from(details.querySelectorAll('[data-preset-country]')).find(item => item.dataset.presetCountry === code);
      if (button && button.form.elements.country_code.value === code) button.form.requestSubmit(button);
    }).catch(() => {});
})();
